import { Wrench } from 'lucide-react';
import SEO from '@/components/SEO';
import { Footer } from '@/components/shared/layout/footer';
import { GlobalHeader } from '@/components/shared/layout/global-header';
import { MobileBottomNavigation } from '@/components/shared/layout/mobile-bottom-navigation';
import { MobileHeader } from '@/components/shared/layout/mobile-header';
import { useIsMobileNav } from '@/hooks/utils/use-mobile';
import { useAuthModal } from '@/stores/ui';

interface MaintenanceProps {
  message?: string | null;
}

const Maintenance = ({ message }: MaintenanceProps) => {
  const { showAuthModal } = useAuthModal();
  const isMobileNav = useIsMobileNav();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEO
        title="Under Maintenance"
        description="CrowdFPL is currently under maintenance. We'll be back soon!"
      />

      {isMobileNav && <MobileHeader onAuthModalOpen={showAuthModal} />}
      {!isMobileNav && <GlobalHeader onAuthModalOpen={showAuthModal} />}

      <div className={`flex-1 flex items-center justify-center px-4 ${isMobileNav ? 'pb-20' : ''}`}>
        <div className="text-center max-w-2xl mx-auto">
          <div className="mb-8 flex justify-center">
            <div className="relative">
              <Wrench className="h-32 w-32 md:h-40 md:w-40 text-primary animate-pulse" />
            </div>
          </div>

          <h1 className="text-6xl md:text-7xl font-black text-primary mb-6">
            Under Maintenance
          </h1>

          <div className="space-y-4 mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground">
              We'll be back soon
            </h2>
            {message ? (
              <p className="text-lg md:text-xl text-muted-foreground">
                {message}
              </p>
            ) : (
              <p className="text-lg md:text-xl text-muted-foreground">
                We're currently performing scheduled maintenance to improve your experience.
              </p>
            )}
            <p className="text-base text-muted-foreground">
              Thank you for your patience.
            </p>
          </div>
        </div>
      </div>

      <Footer hideLinks />
      {isMobileNav && <MobileBottomNavigation />}
    </div>
  );
};

export default Maintenance;

